<app-page-header></app-page-header>

<div class="operations-page">
  @if (showContactAdminEmpty) {
    <div class="capability-empty-state">
      <p>Client access denied</p>
    </div>
  } @else {
  <div class="ops-index-tabs" role="tablist" aria-label="Operational navigation tabs">
    <button
      type="button"
      class="ops-index-tab"
      [class.is-disabled]="capabilities && !capabilities.sequencingEnabled"
      [disabled]="capabilities ? !capabilities.sequencingEnabled : false"
      [attr.title]="capabilities && !capabilities.sequencingEnabled ? 'Indexing is not enabled for this client' : null"
      (click)="navigateToIndexing()">
      <span>Indexing</span>
    </button>
    <button type="button" class="ops-index-tab active" aria-current="page">
      <span>Extraction</span>
    </button>
  </div>

  <div class="content-section">
    <div class="evaluation-section-header">
      <div class="evaluation-section-title-wrap">
        <button
          class="section-back-btn"
          (click)="router.navigate(['/home'])"
          title="Back to Dashboard"
          aria-label="Back to Dashboard">
          <svg
            class="back-arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
        <h2 class="evaluation-section-title">Extraction</h2>
        <div class="section-search-box" [class.is-disabled]="allRows.length === 0" title="Search model">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            [disabled]="allRows.length === 0"
            (input)="onSearchChange()"
            placeholder="Search Document Model" />
        </div>
      </div>

      <div class="header-controls-group">
        <div class="header-controls-context-slot" [class.has-custom-controls]="selectedTimeFilter === 'custom'">
          @if (selectedTimeFilter === 'custom') {
            <div class="custom-date-controls">
              <span class="date-prefix-label">From</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    type="text"
                    [value]="startDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('start', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('start')"
                    (click)="openDateTimePopup('start', $event)"
                    title="Start date and time" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('start', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('start')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [maxDate]="getPopupMaxDate('start')"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="Start time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="Start hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="Start minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="Start period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>

              <span class="date-prefix-label">To</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    [class.is-invalid]="endDateInvalid"
                    type="text"
                    [value]="endDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('end', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('end')"
                    (click)="openDateTimePopup('end', $event)"
                    [attr.title]="dateRangeValidationMessage || 'End date and time'" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('end', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('end')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [minDate]="getPopupMinDate('end')"
                        [maxDate]="getTodayDateForPopup()"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="End time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="End hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="End minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="End period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="filter-select-wrapper">
          <select
            class="filter-select"
            [(ngModel)]="selectedTimeFilter"
            (change)="onTimeFilterChange()"
            title="Date filter">
            <option value="today">Last 24 Hours</option>
            <option value="last7">Last 7 Days</option>
            <option value="last30">Last 30 Days</option>
            <option value="custom">Custom</option>
          </select>
          <span class="material-icons dropdown-indicator" aria-hidden="true">arrow_drop_down</span>
        </div>
      </div>
    </div>

    <section class="kpi-row">
      <article class="kpi-card kpi-unified">
        <h3>Total Requests</h3>
        <p>{{ topMetrics.totalRequests | number:'1.0-0' }}</p>
      </article>
      <article class="kpi-card kpi-unified">
        <h3>Total Pages Processed</h3>
        <p>{{ topMetrics.totalPagesProcessed | number:'1.0-0' }}</p>
      </article>
      <article class="kpi-card kpi-unified">
        <h3>Total LLM Cost</h3>
        <p>{{ formatCostDisplay(topMetrics.totalLlmCost) }}</p>
      </article>
      <article class="kpi-card kpi-unified">
        <h3>Total OCR Cost</h3>
        <p>{{ formatCostDisplay(topMetrics.totalOcrCost) }}</p>
      </article>
      <article class="kpi-card kpi-unified">
        <h3>Total Success Rate</h3>
        <p>{{ topMetrics.successRate | number:'1.2-2' }}%</p>
      </article>
    </section>

    @if (isLoading) {
      <div class="validation-loading-wrapper">
        <div class="page-loading-state">
          <div class="docsila-loader">
            <div class="beat-loader">
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
            </div>
            <p class="loader-text">Loading extraction report...</p>
          </div>
        </div>
      </div>
    } @else {
      @if (allRows.length > 0) {
        <div class="validation-table-wrapper">
          <table class="validation-table">
            <thead>
              <tr>
                <th class="sortable th-with-search">
                  <div class="th-with-search-inline">
                    <button type="button" class="sort-trigger sort-trigger-inline" (click)="sortBy('document_model')">
                      <span>Document Model</span>
                      <span class="sort-icon" [innerHTML]="getSortIcon('document_model')"></span>
                    </button>
                  </div>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('docs_processed')">
                    <span>Total Requests</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('docs_processed')"></span>
                  </button>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('pages_processed')">
                    <span>Total Pages</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('pages_processed')"></span>
                  </button>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('average_duration_seconds')">
                    <span>Avg Duration</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('average_duration_seconds')"></span>
                  </button>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('total_llm_cost')">
                    <span>LLM Cost</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('total_llm_cost')"></span>
                  </button>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('total_ocr_cost')">
                    <span>OCR Cost</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('total_ocr_cost')"></span>
                  </button>
                </th>
                <th class="sortable center">
                  <button type="button" class="sort-trigger" (click)="sortBy('execution_percent')">
                    <span>Success Rate</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('execution_percent')"></span>
                  </button>
                </th>
                <th class="sortable center metric-compact">
                  <button type="button" class="sort-trigger" (click)="sortBy('failures')">
                    <span>Failures</span>
                    <span class="sort-icon" [innerHTML]="getSortIcon('failures')"></span>
                  </button>
                </th>
              </tr>
            </thead>

            <tbody>
              @for (row of displayedRows; track row.document_model) {
                <tr>
                  <td>
                    <span
                      class="document-code-single clickable"
                      (click)="onDocumentModelClick(row.document_model)"
                      [title]="'Open extraction reports for ' + row.document_model">{{ row.document_model }}</span>
                  </td>
                  <td class="center metric-compact">
                    <span class="file-count-badge">{{ row.docs_processed | number:'1.0-0' }}</span>
                  </td>
                  <td class="center metric-compact"><span class="metric-neutral">{{ row.pages_processed | number:'1.0-0' }}</span></td>
                  <td class="center metric-compact"><span class="metric-neutral">{{ row.average_duration_seconds }}s</span></td>
                  <td class="center metric-compact">
                    <div class="metric-dual-line">
                      <span class="metric-line">
                        <span class="metric-line-label">Avg:</span>
                        <span class="metric-line-value">{{ formatCostDisplay(row.avg_llm_cost) }}</span>
                      </span>
                      <span class="metric-line">
                        <span class="metric-line-label">Total:</span>
                        <span class="metric-line-value">{{ formatCostDisplay(row.total_llm_cost) }}</span>
                      </span>
                    </div>
                  </td>
                  <td class="center metric-compact">
                    <div class="metric-dual-line">
                      <span class="metric-line">
                        <span class="metric-line-label">Avg:</span>
                        <span class="metric-line-value">{{ formatCostDisplay(row.avg_ocr_cost) }}</span>
                      </span>
                      <span class="metric-line">
                        <span class="metric-line-label">Total:</span>
                        <span class="metric-line-value">{{ formatCostDisplay(row.total_ocr_cost) }}</span>
                      </span>
                    </div>
                  </td>
                  <td class="center">
                    <div class="accuracy-cell">
                      <div class="accuracy-bar">
                        <div
                          class="accuracy-fill"
                          [style.width.%]="row.execution_percent"
                          [class.high]="row.execution_percent >= 100"
                          [class.medium]="row.execution_percent >= 80 && row.execution_percent < 100"
                          [class.low]="row.execution_percent < 80">
                        </div>
                      </div>
                      <span class="accuracy-text">{{ row.execution_percent | number:'1.2-2' }}%</span>
                    </div>
                  </td>
                  <td class="center metric-compact">
                    <span class="failure-badge" [class.has-failures]="row.failures > 0">{{ row.failures }}</span>
                  </td>
                </tr>
              } @empty {
                <tr class="no-results-row">
                  <td class="empty-cell" colspan="8">
                    @if (searchTerm.trim() && allRows.length > 0) {
                      <p class="empty-state-message">No results found for "{{ searchTerm.trim() }}"</p>
                    } @else {
                      <p class="empty-state-message">No extraction report data available for selected filters.</p>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="validation-table-wrapper no-data-wrapper">
          <p class="no-data-text">No data available</p>
        </div>
      }
    }
  </div>
  }
</div>

